export default "__VITE_ASSET__BKq1fYoH__"